import { ClassTimestampsHelper } from '../ClassHelper';
import Account from '../account/Account';
import RefundPoliceRule from './RefundPoliceRule';

class RefundPolicy extends ClassTimestampsHelper {
  constructor({ account, title, rules = [], status } = {}) {
    super(...arguments);
    this.account = this.ref(account, Account);
    this.title = title;
    this.rules = this.array(rules, RefundPoliceRule);
    this.status = status; // Status
  }
}

export default RefundPolicy;